import { useUserContext } from "../../../../context/userGetContext";
import UserEnvironmentProvider from "../UserEnvironmentProvider";

function UpdateTeamsContextWithoutStore({ contextInfo }) {
  const { updateTeamsContext } = useUserContext();
  const { email, aadObjectId } = contextInfo;
  updateTeamsContext(contextInfo);
  return <UserEnvironmentProvider email={email} aadObjectId={aadObjectId} />;
}

export default UpdateTeamsContextWithoutStore;
